module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-body"
  }, [_c('div', {
    staticClass: "calendar-weeks-header"
  }, _vm._l((7), function(day) {
    return _c('span', {
      key: day,
      staticClass: "calendar-week-header"
    }, [_vm._v(_vm._s(_vm.localizedWeekDay(day - 1)))])
  })), _vm._v(" "), _c('div', {
    staticClass: "calendar-dates"
  }, _vm._l((_vm.weeks), function(week) {
    return _c('calendar-week', {
      key: week,
      attrs: {
        "week": week
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-700d7246"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarBody.vue
// module id = 548
// module chunks = 0